import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc Transactions - get All by vendor id
 */
export function getVendorTransactionsAction(id) {
    let vendorId = "";
    if (id) {
        vendorId = id
    } else {
        vendorId = localStorage.getItem("ID")
    }
   
    let url = UrlConstants.vendorTransactionsUrl;
    url = url.replace("{id}",vendorId);

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: []
              });
          }
      });
    }  
}
/**
 * @desc get all tasks of vendor by transactionId
 * @param {*} transactionId 
 */
export function getVendorTasksAction(transactionId) {  

    let vendorId = localStorage.getItem("ID")
    let url = UrlConstants.vendorTasksUrl;
    url = url.replace("{transactionId}",transactionId);
    url = url.replace("{vendorId}",vendorId);
    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TASKS,
                  vendorTasks: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TASKS,
                  vendorTasks: []
              });
          }
      });
    }  
}



/**
 * @desc Transactions - get All by vendor id
 */
export function getVendorTransactionsActionNew(id) {
    let vendorId = "";
    if (id) {
        vendorId = id
    } else {
        vendorId = localStorage.getItem("ID")
    }
   
    let url = UrlConstants.vendorTransactionsUrlNew;
    url = url.replace("{id}",vendorId);

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: []
              });
          }
      });
    }  
}

/**
 * @desc get contingencies of owner Transactions in which vendor is involved
 */
export function getAppointmentVendorContingenciesAction(id,transactionId) {
    let vendorId = "";
    if (id) {
        vendorId = id
    } else {
        vendorId = localStorage.getItem("ID")
    }
   
    let url = UrlConstants.appoVendorContingenciesUrl;
    url = url.replace("{id}",vendorId);
    url = url.replace("{transactionId}",transactionId);

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_VENDOR_CONTINGENCIES,
                  vendorContingencies: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_VENDOR_CONTINGENCIES,
                  vendorContingencies: []
              });
          }
      });
    }  
}

/**
 * @desc get Transactions of owner in which vendor is involved
 */
export function getAppointmentVendorTransactionsAction(id,ownerId) {
    let vendorId = "";
    if (id) {
        vendorId = id
    } else {
        vendorId = localStorage.getItem("ID")
    }
   
    let url = UrlConstants.appoVendorTransactionsUrl;
    url = url.replace("{id}",vendorId);
    url = url.replace("{ownerId}",ownerId);

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_VENDOR_TRANSACTIONS,
                  vendorTransactions: []
              });
          }
      });
    }  
}

